<script setup>
import { computed } from 'vue';

const props = defineProps({
  reactions: { type: Object, default: () => ({}) },
  currentUserId: { type: Number, default: null },
  readonly: { type: Boolean, default: false },
});

const emit = defineEmits(['toggle']);

const items = computed(() =>
  Object.entries(props.reactions || {})
    .filter(([, userIds]) => userIds?.length)
    .map(([emoji, userIds]) => ({
      emoji,
      count: userIds.length,
      reacted: props.currentUserId
        ? userIds.includes(props.currentUserId)
        : false,
    }))
);
</script>

<template>
  <div v-if="items.length" class="flex flex-wrap gap-1 mt-1">
    <button
      v-for="item in items"
      :key="item.emoji"
      type="button"
      :disabled="readonly"
      class="flex items-center gap-1 px-1.5 py-0.5 text-xs rounded-full border border-n-slate-7"
      :class="
        item.reacted
          ? 'bg-n-slate-5 text-n-slate-12'
          : 'bg-n-alpha-2 text-n-slate-11'
      "
      @click="emit('toggle', item.emoji)"
    >
      <span>{{ item.emoji }}</span>
      <span>{{ item.count }}</span>
    </button>
  </div>
</template>
